import React from 'react';
import styled from 'styled-components';

const HomeContainer = styled.div`
  /* Optional: Add styles for centering or sizing the iframe container */
  display: flex; 
  justify-content: center;
  align-items: flex-start; /* Change center to flex-start for top alignment */
  height: 100%;
  padding: 20px; /* Add some padding */
`;

// Remove PageTitle and Content styled components as they are no longer used
// const PageTitle = ... 
// const Content = ...

const VideoFrame = styled.iframe`
  border: none; /* Remove default iframe border */
  max-width: 100%; /* Ensure iframe scales down on smaller screens */
  aspect-ratio: 16 / 9; /* Maintain video aspect ratio */
`;

const Home: React.FC = () => {
  return (
    <HomeContainer>
      {/* Replace existing content with the YouTube iframe */}
      <VideoFrame 
        width="853" // Standard 16:9 width
        height="480" // Standard 16:9 height
        src="https://www.youtube.com/embed/WMHB8Xm24Wo"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        allowFullScreen
      >
      </VideoFrame>
    </HomeContainer>
  );
};

export default Home; 